/* eslint-disable */
// TODO: conver to functional component
import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';
import Slider from "react-slick";

import Component from "components/component";
import {
  isSelectable,
  getDisplayPriceOfSizeSelection
} from "lib/helpers";

import DefaultOption from "./default-option";
import TextOption from "./text-option";
import DefaultOptionSelection from "./default-option-selection";
import SizeOptionSelection from "./size-option-selection";
import SelectionPrompt from "./selection-prompt";

const settings = {
  speed: 500,
  dots: false,
  arrows: false,
  infinite: false,
  draggable: true,
  focusOnSelect: false,
  slidesToShow: 3,
  swipeToSlide: true,
  centerMode: false
};

export default class TextOptionRow extends Component {
  static propTypes = {
    optionType: ImmutablePropTypes.map.isRequired,
    optionValues: ImmutablePropTypes.map.isRequired,
    selection: ImmutablePropTypes.map,
    handleClick: PropTypes.func.isRequired,
    selections: ImmutablePropTypes.map,
    optionValueRestrictions: ImmutablePropTypes.map,
    openModal: PropTypes.func.isRequired,
    showOptionPrice: PropTypes.bool.isRequired,
    quantityCount: PropTypes.number.isRequired,
    selectedVariant: ImmutablePropTypes.map,
  };

  static defaultProps = {
    showOptionPrice: false
  };

  constructor(props) {
    super(props);
    this.state = { isOpen: false, showAdditionalOptions: false };
  }

  render() {
    if (this.props.optionValues.isEmpty()) return null;

    const { isOpen, showAdditionalOptions } = this.state;
    const {
      optionType,
      optionValues,
      selection,
      handleClick,
      selections,
      optionValueRestrictions,
      showOptionPrice,
      quantityCount,
      selectedVariant,
      userRole,
    } = this.props;
    const optionName = optionType.get("displayName");
    const toggleClass = isOpen ? "toggle-row open" : "toggle-row";
    const selectionIsPresent = !!selection;
    let selectionId,
      selectionName,
      selectionUpchargeAmount,
      selectionImage,
      selectionDisplayUpchargeAmount,
      selectionCustomValue,
      isCustom;
    let selectionIndex = 0;

    if (selectionIsPresent) {
      selectionId = selection.get("id");
      selectionName = selection.get("displayName");
      selectionUpchargeAmount = selection.get("upchargeAmount");
      selectionCustomValue = selection.get("customValue");
      isCustom = selection.get("isCustom");
      selectionImage = selection.get("thumbnailImage");
      selectionIndex = optionValues
        .valueSeq()
        .findIndex(ov => ov.get("id") === selectionId);
      selectionDisplayUpchargeAmount = selection.get("displayUpchargeAmount");
    }

    const firstTwelveValues = optionValues.slice(0, 12);
    const remainingValues = optionValues.slice(13, optionValues.length);

    return (
      <div>
        <div className="product-options-title-row desktop-only">
          <p className="lined-title construction-row-title">
            <span>{optionName}</span>
          </p>
        </div>

        <div className="product-options-row option-columns two-columns">
          <div className="product-options-wrapper-mobile mobile-only">
            <a href="#" className={toggleClass} onClick={this.toggleOpen} />

            {!isOpen &&
              !selectionIsPresent && (
                <div>
                  <p className="option-name">{optionName}</p>
                  <SelectionPrompt name={selectionName} />
                </div>
              )}

            {!isOpen &&
              selectionIsPresent &&
              selection.get("optionType") === "Bed Frame Size" && (
                <SizeOptionSelection
                  customValue={selectionCustomValue}
                  isCustom={isCustom}
                  optionName={optionName}
                  selectionName={selectionName}
                  quantityCount={quantityCount}
                  displayPrice={(() => {
                    const sizeSelection = selections.find(ov => {
                      return (
                        SIZE_OPTION_NAMES.indexOf(ov.get("optionType")) > -1
                      );
                    });

                    if (userRole !== 'trade_user') {
                      const listPrice = selectedVariant.get('displayListPrice');

                      return listPrice;
                    }

                    return getDisplayPriceOfSizeSelection(
                      sizeSelection,
                      selectedVariant
                    );
                  })()}
                />
              )}

            {!isOpen &&
              selectionIsPresent &&
              selection.get("optionType") !== "Bed Frame Size" && (
                <DefaultOptionSelection
                  optionName={optionName}
                  selectionName={selectionName}
                  upchargeAmount={selectionUpchargeAmount}
                  thumbnailImage={selectionImage}
                  displayUpchargeAmountOverride={selectionDisplayUpchargeAmount}
                  showQuantity={
                    selectionUpchargeAmount > 0 && quantityCount > 1
                  }
                  quantityCount={quantityCount}
                />
              )}

            {isOpen && (
              <div>
                <p className="option-name">{optionName}</p>
                <div className="product-options-slider-wrapper">
                  <Slider {...settings} slickGoTo={selectionIndex}>
                    {optionValues.valueSeq().map((optionValue, key) => {
                      const id = optionValue.get("id");
                      const selectable = isSelectable(
                        selections,
                        optionValueRestrictions,
                        id
                      );
                      const displayUpchargeAmount = optionValue.get(
                        "displayUpchargeAmount"
                      );

                      return (
                        <div key={id}>
                          <TextOption
                            optionValue={optionValue}
                            isSelected={selectionId === id}
                            handleClick={handleClick}
                            selectable={selectable}
                            showOptionPrice={showOptionPrice}
                            displayUpchargeAmount={displayUpchargeAmount}
                            inSlider
                          />
                        </div>
                      );
                    })}
                  </Slider>
                </div>

                {(optionType.get("displayName") === "Construction" ||
                  optionType.get("displayName") === "Bed Frame Size") && (
                  <p className="sleeping-info">
                    <button
                      href="#"
                      className="show-more-button large center"
                      onClick={this.openSleepingInfo}
                    >
                      View Sleeping Size and Dimensions
                    </button>
                  </p>
                )}
              </div>
            )}
          </div>

          <div className="desktop-only options-container">
            {firstTwelveValues.valueSeq().map((optionValue, key) => {
              const id = optionValue.get("id");
              const selectable = isSelectable(
                selections,
                optionValueRestrictions,
                id
              );
              const noMargin = (key + 1) % 3 === 0;
              const displayUpchargeAmount = optionValue.get(
                "displayUpchargeAmount"
              );

              return (
                <TextOption
                  key={id}
                  optionValue={optionValue}
                  isSelected={selectionId === id}
                  handleClick={handleClick}
                  selectable={selectable}
                  noMargin={noMargin}
                  showOptionPrice={showOptionPrice}
                  displayUpchargeAmount={displayUpchargeAmount}
                />
              );
            })}

            {remainingValues.size !== 0 &&
              !showAdditionalOptions && (
                <button
                  className="show-more-button large center"
                  onClick={this.showMore}
                >
                  Show More
                </button>
              )}

            <div className="additional-options">
              {showAdditionalOptions &&
                remainingValues.valueSeq().map((optionValue, key) => {
                  const id = optionValue.get("id");
                  const selectable = isSelectable(
                    selections,
                    optionValueRestrictions,
                    id
                  );

                  return (
                    <DefaultOption
                      key={id}
                      optionValue={optionValue}
                      isSelected={selectionId === id}
                      handleClick={handleClick}
                      selectable={selectable}
                    />
                  );
                })}
            </div>
          </div>
        </div>

        <div className="desktop-only">
          {optionType.get("displayName") === "Bed Frame Size" && (
            <p className="sleeping-info">
              <button
                href="#"
                className="show-more-button large center"
                onClick={this.openSleepingInfo}
              >
                View Sleeping Size and Dimensions
              </button>
            </p>
          )}
        </div>
      </div>
    );
  }

  toggleOpen = e => {
    if (e) e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };

  showMore = e => {
    e.preventDefault();
    this.setState({ showAdditionalOptions: true });
  };

  openSleepingInfo = e => {
    e.preventDefault();
    this.props.openModal("sleeping-info");
  };
}
